const modal = $('.modal');
/**
 * Stack of methods to call when updating or closing the modal
 * @type {((boolean) => void)[]}
 */
const modalCloseActions = [];
let isModalOpen = false;

/**
 * Update Modal Window Content
 *
 */
function updateContent(content, update) {
    if (content || content === '') {
        modal.find('.modal-content').html(content);
    } else {
        if (update !== true) {
            modal.find('.modal-content').empty();
        }
    }
}

/**
 * Update Modal Window Content
 *
 */
function prependContent(content) {
    modal.find('.modal-content').prepend(content);
}

/**
 * Update Modal Window Buttons
 *
 */
function updateButtons(buttons, update) {
    var actions = modal.find('.modal-actions');

    if (buttons && buttons.length > 0) {
        actions.empty();

        for (var b = 0; b < buttons.length; b++) {
            createButton(buttons[b], actions);
        }
    } else {
        if (update !== true || (buttons && buttons.length == 0)) {
            actions.empty();

            createButton({
                label: 'OK', type: 'button', callback: Belimo.Modal.close
            }, actions);
        }
    }
}

/**
 * Create Modal Window Button
 *
 * @param config {null|{html?: string, type: string, disabled?: boolean, label: string, classes?: string, inputField: jQuery, callback: () => void}}
 * @param actions
 */
function createButton(config, actions) {
    var button;

    if (!config) {
        return;
    }

    if (config.html) {
        button = $(config.html);
    } else {
        button = $('<button/>');
        button.attr('type', config.type);
        if (config.disabled) {
            button.attr('disabled', 'disabled');
        } else {
            button.removeAttr('disabled');
        }
        button.html(config.label);
        if (config.classes) button.addClass(config.classes);
    }

    // config.inputfield needs to be a jquery object!
    if (config.inputField && config.inputField instanceof jQuery) {

        button.prop('disabled', config.inputField.val() == false);
        config.inputField.keyup(function () {
            button.prop('disabled', config.inputField.val() == false);
        });
    }

    button.on('click', function () {
        if (config.callback) config.callback();
    });

    actions.append(button);
}

/**
 * Place the modal at an offset of a specific element
 * This is used e.g. on the SMPLCTY PDP to show the modal below the orange stage component
 * @param elementToOffsetFrom {HTMLElement}
 */
function placeModalAtOffset(elementToOffsetFrom) {
    const html = document.querySelector('html');
    // Disable scrolling
    html.style.overflowY = 'hidden';
    // Scroll to Element
    elementToOffsetFrom.scrollIntoView();
    // Get offset values
    const offsetElementClientRect = elementToOffsetFrom.getClientRects()[0];
    const modalOffsetTop = offsetElementClientRect.bottom;
    // Set Modal position
    modal.css('top', `${modalOffsetTop}px`);
    modal.find('.content').css('max-height', `calc(100vh - ${modalOffsetTop}px)`);
}

/**
 * Set Modal offset to given element and register event listeners
 * @param elementToOffsetFrom {HTMLElement}
 * @returns {((boolean) => void)} unregisters event listeners and resets modal
 */
function addModalOffset(elementToOffsetFrom) {
    const eventListener = () => {
        if (isModalOpen) {
            placeModalAtOffset(elementToOffsetFrom);
        }
    };
    eventListener();
    addEventListener('resize', eventListener);
    return (isClosing) => {
        removeEventListener('resize', eventListener);
        // Reset all changes made by placing the modal
        if (isClosing) {
            // Run this after 500ms only to account for the animation
            setTimeout(() => {
                resetHtmlOverflow();
                modal.css('top', '');
                modal.find('.content').css('max-height', '');
            }, 500);
        }
    };
}

function resetHtmlOverflow() {
    const html = document.querySelector('html');
    html.style.overflowY = '';
}

/**
 * Resets modal actions in the stack
 */
function resetModalActions(isClosing = false) {
    // Reset actions
    while (modalCloseActions.length > 0) {
        modalCloseActions.pop()(isClosing);
    }
}

/**
 * Update Modal configuration
 * @param configuration {{buttonAlignment?: 'left'|'right', heading?: string, elementToOffsetFrom?: HTMLElement, additionalFooter: string}}
 */
function updateConfiguration(configuration) {
    const modalActions = modal.find('.modal-actions');
    const modalHeading = modal.find('.modal-heading');
    const modalFooter = modal.find('.modal-footer');
    // Reset actions
    resetModalActions();
    // buttonAlignment // default: left
    modalActions.toggleClass('align-end', configuration.buttonAlignment === 'right');
    // heading // default: undefined
    modalHeading.text(configuration.heading ?? '');
    // Additional Footer
    modalFooter.html(configuration.additionalFooter ?? '');
    // elementToOffsetFrom // default: undefined
    if (configuration.elementToOffsetFrom) {
        modalCloseActions.push(addModalOffset(configuration.elementToOffsetFrom));
    }
}


/**
 * Handle global open/update/close events
 *
 */
$(document).on('modal-on', function (ev, content, buttons, configuration) {
    isModalOpen = true;
    $(document).trigger('overlay-on', ['', true]);

    updateContent(content);
    updateButtons(buttons);
    updateConfiguration(configuration);

    modal.addClass('toggle-on');
}).on('modal-off', function (ev) {
    isModalOpen = false;
    $(document).trigger('overlay-off');
    modal.removeClass('toggle-on');

    updateContent();
    updateButtons();

    // Reset actions
    resetModalActions(true);

    // Reset overflow-y on html
    resetHtmlOverflow();
}).on('modal-update', function (ev, content, buttons, configuration) {
    updateContent(content, true);
    updateButtons(buttons, true);
    updateConfiguration(configuration);
}).on('modal-update-buttons', function (ev, buttons) {
    updateButtons(buttons, true);
}).on('modal-prepend', function (ev, content) {
    prependContent(content);
});
